<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card">

        
        <h4>Support Cases</h4>
        
        <div class="p-mb-4 p-d-flex p-jc-between p-toolbar">
          <div>
            <span class="p-input-icon-left">
              <i class="pi pi-search" />
              <InputText
                v-model="globalSearch"
                placeholder="Global Search"
                style="margin-right: 0.5em"
                @input="updateSearch"
              />
            </span>
          </div>
        </div>
  
      </div>
    </div>

    <div style="overflow-x: scroll;">
      <SupportCaseTable
        :key="SupportCaseTableKey1"
        :supportCases="supportCases"
        :loading="loading"
      />
    </div>
    
  </div>
</template>

<script>
import SupportCaseService from "@/service/SupportCaseService";

import SupportCaseTable from '../universalComponents/supportCase/SupportCaseTable'

export default {
  components: {
    SupportCaseTable
  },
  data: () => ({
    SupportCaseService: new SupportCaseService(),
    globalSearch: '',
    supportCases: [],
    SupportCaseTableKey: 0,
    requesting: false,
    SupportCaseFormDialog: false,
    reloadSupportCaseForm: 0,
    disabledArr: [],
    SupportCase: {}
  }),
  computed: {
    SupportCaseTableKey1: {
      set(val) {
        this.SupportCaseTableKey++
      },
      get() {
        return 'SupportCaseTable' + this.SupportCaseTableKey.toString()
      }
    },
    loading() {
      if (this.SupportCase && this.SupportCase[0]) {
        return false
      } else {
        if (this.requesting) {
          return true
        } else {
          return false
        }
      }
    }
  },
  created() {
    this.getAllSupportCaseByHard()
    if (this.$route.query.search !== '') {
      this.updateSearch('')
    }
  },
  watch: {
    globalSearch(val) {
      this.SupportCaseTableKey1++
    },
    SupportCase(val) {
      if (val && Array.isArray(val)) {
        this.SupportCaseTableKey1++
      }
    }
  },
  methods: {
    getAllSupportCaseByHard() {
      this.supportCases = []
      this.requesting = true

      this.SupportCaseService
        .getAllSupportCases()
        .then(data => {
          this.requesting = false
          this.supportCases = data
        })
        .catch((e) => {
          
            
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting SupportCase",
          //   life: 5000,
          // })
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "SupportCase"'
          })
        });
    },
    updateSearch(e) {
      this.$router.push({ query: { search: e } });
    }
  }
}
</script>

<style>

</style>